/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrentUserDetailOrganizationSettings
 */
export interface CurrentUserDetailOrganizationSettings {
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserDetailOrganizationSettings
     */
    billing_enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CurrentUserDetailOrganizationSettings
     */
    is_screener_customer: boolean;
}

/**
 * Check if a given object implements the CurrentUserDetailOrganizationSettings interface.
 */
export function instanceOfCurrentUserDetailOrganizationSettings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "billing_enabled" in value;
    isInstance = isInstance && "is_screener_customer" in value;

    return isInstance;
}

export function CurrentUserDetailOrganizationSettingsFromJSON(json: any): CurrentUserDetailOrganizationSettings {
    return CurrentUserDetailOrganizationSettingsFromJSONTyped(json, false);
}

export function CurrentUserDetailOrganizationSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentUserDetailOrganizationSettings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'billing_enabled': json['billing_enabled'],
        'is_screener_customer': json['is_screener_customer'],
    };
}

export function CurrentUserDetailOrganizationSettingsToJSON(value?: CurrentUserDetailOrganizationSettings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'billing_enabled': value.billing_enabled,
        'is_screener_customer': value.is_screener_customer,
    };
}

